
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateBusinessdivisionDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    shortname: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    icon: new FormControl<string | undefined>(undefined, [Validators.maxLength(50), Validators.pattern(new RegExp("^[a-z0-9_]*$", ""))]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    supervisorId: new FormControl<number | undefined>(undefined),
})
;
}
      